module.exports = __webpack_public_path__ + "files/b4f5090f59aa6737b46e5094767a96c2.png";